import { Stack, StackProps, Text } from "@chakra-ui/react";

import { ExpansionRow } from "./SortableDynamicTable";

export const ExpansionRowStat = ({
  label,
  value,
  ...rest
}: Pick<ExpansionRow, "label" | "value"> & StackProps) => (
  <Stack spacing={2} {...rest}>
    {label ? (
      <Text
        textStyle="label2"
        color="grey.600"
        whiteSpace="nowrap"
        fontWeight="bold"
      >
        {label}
      </Text>
    ) : null}
    {typeof value === "string" ? (
      <Text textStyle="body2" color="grey.700">
        {value}
      </Text>
    ) : (
      value
    )}
  </Stack>
);

export default ExpansionRowStat;
